import { Token } from '@pancakeswap/sdk'
import { Flex, Message, MessageText, useMatchBreakpoints } from '@pancakeswap/uikit'
import { useTranslation } from '@pancakeswap/localization'
import { memo } from 'react'
import { useVaultApy } from 'hooks/useVaultApy'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { DeserializedPool } from '@pancakeswap/uikit/src/widgets/Pool'

import ExtendButton from '../Buttons/ExtendDurationButton'
import useAvgLockDuration from '../hooks/useAvgLockDuration'

interface ConvertToLockProps {
  pool: DeserializedPool<Token>,
  stakingToken: Token
  currentStakedAmount: number
  isInline?: boolean
}

const ConvertToLock: React.FC<React.PropsWithChildren<ConvertToLockProps>> = ({
  pool,
  stakingToken,
  currentStakedAmount,
  isInline,
}) => {
  const { t } = useTranslation()
  const { chainId } = useActiveWeb3React()
  const { isMobile } = useMatchBreakpoints()
  const isTableView = isInline && !isMobile
  const { avgLockDurationsInSeconds } = useAvgLockDuration(pool.vaultKey)
  const { lockedApy } = useVaultApy({ chainId, vaultKey: pool.vaultKey, duration: avgLockDurationsInSeconds })

  return (avgLockDurationsInSeconds && lockedApy) ?
      <Message
        variant="warning"
        action={
          <Flex mt={!isTableView && '8px'} flexGrow={1} ml={isTableView && '80px'}>
            <ExtendButton
              pool={pool}
              modalTitle={t('Convert to Lock')}
              lockEndTime="0"
              lockStartTime="0"
              stakingToken={stakingToken}
              currentLockedAmount={currentStakedAmount}
            >
              {t('Convert to Lock')}
            </ExtendButton>
          </Flex>
        }
        actionInline={isTableView}
      >
        <MessageText>
          {t('Lock staking users are earning an average of %amount%% APR.', {
            amount: lockedApy ? parseFloat(lockedApy).toFixed(2) : 0,
          })}
        </MessageText>
      </Message> :
      <ExtendButton
        pool={pool}
        modalTitle={t('Convert to Lock')}
        lockEndTime="0"
        lockStartTime="0"
        stakingToken={stakingToken}
        currentLockedAmount={currentStakedAmount}
      >
        {t('Convert to Lock')}
      </ExtendButton>
}

export default memo(ConvertToLock)
